// eslint-disable-next-line no-restricted-imports
import { InventoryManagementMethodEnum } from '@eih-netbroker/api-order';

export const InventoryManagementMethod = InventoryManagementMethodEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InventoryManagementMethod = (typeof InventoryManagementMethod)[keyof typeof InventoryManagementMethod];
